@if (modal?.visible) {
  <article class="point__container">
    <div class="point__backdrop">
      @if (workspaces && point) {
        <div class="point__animation">
          <pp-point-modal-header
            [ppAttachmentUploading]="attachmentUploading"
            [ppFull]="true"
            [ppPoint]="point"
            [ppPointId]="_id"
            [ppWorkspaceId]="workspaceId"
            [(ppPointDetails)]="pointDetails"
            (ppHide)="hide()"
            [ppSite]="site"
            [ppNew]="_id === NEW_POINT_ID"
            [ppDetailsFetched]="detailsFetched"
            (ppUpdate)="generatePoint(point)"
          ></pp-point-modal-header>
          <pp-point-container
            [ppNew]="_id === NEW_POINT_ID"
            [ppPointId]="_id"
            [ppSide]="isDesktopScreen && !!workspaces[point?.workspaceRef.id]?.siteImageRef"
            [ppSitePlan]="!!workspaces[point?.workspaceRef.id]?.siteImageRef"
            (click)="$event.stopPropagation()"
            (ppUpdateScrollPosition)="updateScrollPosition($event)"
            [ppFull]="true"
          >
            <ng-container header>
              <header>
                <pp-point-action-bar
                  [ppNew]="_id === NEW_POINT_ID"
                  [ppPointId]="_id"
                  [ppWorkspaceId]="point?.workspaceRef.id"
                  [ppCanEdit]="canEditPoint && !processingSave"
                  [ppCanDelete]="canDeletePoint"
                  [ppFull]="true"
                  [ppUser]="user"
                  [ppScrollPosition]="scrollPosition"
                ></pp-point-action-bar>
              </header>
            </ng-container>
            <ng-container body>
              <section>
                <pp-point-description
                  [ppNew]="_id === NEW_POINT_ID"
                  [ppPointId]="_id"
                  [ppWorkspaceId]="point?.workspaceRef.id"
                  [ppDescription]="point?.description"
                  [ppDescriptionRich]="point?.descriptionRich"
                  [ppCanEdit]="canEditPoint && !processingSave"
                ></pp-point-description>
              </section>
              @if (relatedPointsFlagEnabled && point?._id) {
                <section aria-label="Related points">
                  <pp-related-points
                    [ppRelationships]="point.relationships"
                    [ppPointId]="point._id!"
                    [ppWorkspaceId]="workspaceId"
                    [ppAccountId]="workspace.accountId"
                    [ppIsNewPoint]="_id === NEW_POINT_ID"
                  ></pp-related-points>
                </section>
              }

              <div class="point__custom-fields">
                <pp-point-fields
                  [ppNew]="_id === NEW_POINT_ID"
                  [ppPointId]="_id"
                  [ppWorkspaceId]="point?.workspaceRef.id"
                  [ppTags]="point?.tags"
                  [ppCanEdit]="canEditPoint"
                  [ppAssignees]="point?.assignees"
                ></pp-point-fields>
              </div>
              @defer (on idle) {
                @if (!isDesktopScreen) {
                  <section class="point__mobile-plan">
                    <pp-point-plan
                      ppModule="point"
                      [ppPointId]="_id"
                      [ppWorkspaceId]="point?.workspaceRef.id"
                      [ppCanEdit]="canEditPoint && !processingSave"
                    ></pp-point-plan>
                  </section>
                }
                <section data-m-target="Point attachments section">
                  @if (point) {
                    <pp-point-attachments
                      [ppNew]="_id === NEW_POINT_ID"
                      [ppWorkspaceId]="point?.workspaceRef.id"
                      [ppPointId]="_id"
                      [ppCanEdit]="canEditPoint && !processingSave"
                      [ppFull]="true"
                    ></pp-point-attachments>
                  }
                </section>
                @if (_id !== NEW_POINT_ID) {
                  <section>
                    <pp-point-activity
                      [ppWorkspaceId]="point?.workspaceRef.id"
                      [ppPointId]="_id"
                      [ppCommentsEnabled]="commentsEditable && !!point"
                      [ppDetailsFetched]="freshPointFetched"
                    ></pp-point-activity>
                  </section>
                }
              }
            </ng-container>
            <ng-container footer>
              @if (_id !== NEW_POINT_ID && commentsEditable) {
                @defer (on idle) {
                  <div
                    data-m-target="Point comment input field"
                    class="point__comment-input"
                    [ngClass]="{ 'point__comment-input--iPhone': isMobile && isiPhone }"
                  >
                    <pp-point-comment-input
                      [ppWorkspaceId]="point?.workspaceRef.id"
                      [ppPointId]="_id"
                    ></pp-point-comment-input>
                  </div>
                }
              }
              @if (_id === NEW_POINT_ID) {
                <footer class="newPoint__footer">
                  <pp-button
                    ppId="cancelCreateNewPointBtn"
                    ppStyle="text"
                    (ppAction)="hide()"
                    data-test="cancelButton"
                  >
                    {{ 'cancel' | ppTranslate }}
                  </pp-button>
                  <pp-button
                    ppTooltip
                    [ppTitle]="emptyTitle ? ('tooltip_title_empty' | ppTranslate) : ''"
                    ppStyle="primary"
                    ppId="createNewPointBtn"
                    (ppAction)="save()"
                    [ppDisabled]="processingSave || attachmentUploading || emptyTitle"
                    [ppProcess]="processingSave"
                    data-test="createPointButton"
                  >
                    {{
                      !(point?.pins?.length > 0 || point?.polygons?.length > 0) &&
                      workspace?.siteImageRef
                        ? ('create_point_no_location' | ppTranslate)
                        : ('create_point' | ppTranslate)
                    }}
                  </pp-button>
                </footer>
              }
            </ng-container>
            @if (isDesktopScreen) {
              <ng-container side>
                @defer (on idle) {
                  @if (point || _id === NEW_POINT_ID) {
                    <pp-point-plan
                      ppModule="point"
                      [ppFull]="true"
                      [ppCanEdit]="canEditPoint && !processingSave"
                      [ppWorkspaceId]="point?.workspaceRef.id"
                      [ppPointId]="_id"
                    ></pp-point-plan>
                  }
                }
              </ng-container>
            }
          </pp-point-container>
        </div>
      }
    </div>
  </article>
}
